addEventListener("shown.bs.modal", ({ target }) => {
  if (target.matches("#user-modal")) {
    document.getElementById("term").focus()
  }
})
